module.exports = __webpack_public_path__ + "img/other-blue.6872e248.png";